import { httpPost } from "./httpService";

export function listAdminEntities(params) {
  return httpPost("/admin/entity/v1/list", params);
}

export function listAdminEntityOptions(params) {
  return httpPost("/admin/entity/v1/listOptions", params);
}

export function getAdminEntityDetail(entityId) {
  return httpPost("/admin/entity/v1/detail", { entityId });
}

export function createAdminEntity(payload) {
  return httpPost("/admin/entity/v1/create", payload);
}

export function updateAdminEntity(payload) {
  return httpPost("/admin/entity/v1/update", payload);
}

export function deleteAdminEntity(entityId) {
  return httpPost("/admin/entity/v1/delete", { entityId });
}
